if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: false,
        showStickyATC: false,
        currentAvailableOptions: [],
        options: [],
        init() {
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderVariant(e.detail.html);
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
          });

          // Sticky Bar Visibility Logic
          // Sticky Bar Visibility Logic
          // We target the main buy buttons container block.
          // We use the class .x-product-{sectionId} as it is reliable and unique to the section.
          const mainBuyButtons = document.querySelector(`.x-product-${sectionId} .x-block-buy-buttons`);

          if (mainBuyButtons) {
            const observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                // Show sticky bar when main Buy Buttons are NOT visible (scrolled past).
                // If it is intersecting, it means we see the buttons -> hide sticky.
                // If not intersecting, check if we are below it (top < 0).
                this.showStickyATC = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              });
            }, { threshold: 0 });
            observer.observe(mainBuyButtons);
          } else {
            // Fallback if specific block not found, try finding specific button inside the form, avoiding sticky one.
            // The main product form usually has id starting with product-form-{sectionId} (without 'sticky')
            // But we don't have the full ID here easily without logic.
            // Let's try traversing.
            const mainForm = document.querySelector(`#product-form-${sectionId}`);
            if (mainForm) {
              const btn = mainForm.querySelector('.add_to_cart_button');
              if (btn) {
                const observer = new IntersectionObserver((entries) => {
                  entries.forEach(entry => {
                    this.showStickyATC = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                  });
                }, { threshold: 0 });
                observer.observe(btn);
              }
            }
          }
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options).forEach((option) => {
            option.removeAttribute('selected');
            if (option.selected) option.setAttribute('selected', '');
          });
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}